export const determineReferralType = ({
  fbclid,
  gclid,
  referralSource,
  adsid,
  platform,
  mailId,
  blogUrl,
  srcBlog,
}: any) => {
  if (fbclid && adsid) {
    return 'ads-fanpage-click'
  } else if (adsid && (referralSource?.includes('youtube.com') || platform === 'youtube')) {
    return 'ads-youtube-click'
  } else if (gclid) {
    return 'ads-search-click'
  } else if (fbclid || (referralSource && referralSource.includes('facebook'))) {
    return 'organic-fanpage-click'
  } else if (
    referralSource &&
    ((referralSource.includes('google') &&
      !referralSource.includes('google.android') &&
      !referralSource.includes('accounts.google')) ||
      referralSource.includes('yahoo') ||
      referralSource.includes('bing') ||
      referralSource.includes('coccoc'))
  ) {
    return 'organic-search-click'
  } else if (referralSource && referralSource.includes('youtube.com')) {
    return 'organic-youtube-click'
  } else if (mailId) {
    return 'organic-email-click'
  } else if (blogUrl && srcBlog) {
    return 'organic-blog-click'
  } else if (
    referralSource &&
    !referralSource.includes('google.android') &&
    !referralSource.includes('accounts.google')
  ) {
    return 'organic-offpage-click'
  } else {
    return 'direct'
  }
}
